import axios from 'axios';
import { UserUrl } from "./AUrl";
import { LoginResponse } from "./login";
import { ApiResponse } from "../interfaces";

export type SsoLoginType = (dfn_token: string) => Promise<ApiResponse<LoginResponse>>;


export async function ssoLogin(dfn_token: string): Promise<ApiResponse<LoginResponse>> {
    const url = new UserUrl().ssoLogin;

    try {
        const response = await axios.post<LoginResponse | string>(
            url,
            { dfn_token },
            {
                headers: { 'Content-Type': 'application/json' },
                // Accept all HTTP status codes
                validateStatus: () => true
            }
        );

        if (response.status === 200 && typeof response.data !== "string") {
            return { status: response.status, data: response.data };
        } else {
            return { status: response.status, error: response.data as string };
        }
    } catch (error) {
        if (axios.isAxiosError(error)) {
            return {
                status: error.response?.status || 500,
                error: error.response?.data || error.message
            };
        } else {
            return { status: 500, error: "An unexpected error occurred" };
        }
    }
}
